import React, { lazy, Suspense } from "react";

import Herosection from "../components/Herosection";
import ProductAction from "../components/ProductAction";
import TextCarosul from "../components/TextCarosul";
import FAQs from "../components/FAQs";
import LinksTab from "../components/LinksTab";
import ClientRows from "../components/ClientRows";

const ThreeSixtyView = lazy(() => import("../components/ThreeSixtyView"));
const ProductUsageView = lazy(() => import("../components/ProductUsageView"));
const Testimonials = lazy(() => import("../components/Testimonials"));

function Home() {
  return (
    <>
      <Herosection />
      <Suspense fallback={<div>loading...</div>}>
        <ThreeSixtyView />
      </Suspense>
      <Suspense>
        <ProductUsageView />
      </Suspense>
      <ClientRows />
      <ProductAction />
      <TextCarosul />
      <Suspense>
        <Testimonials />
      </Suspense>
      <FAQs />
      <div
        style={{
          width: "100%",
          height: "auto",
          background: "#FFFFFF",
          padding: "0px 20px",
        }}
      >
        <LinksTab />
      </div>
    </>
  );
}

export default React.memo(Home);
